import {toggleGenericFeaturePath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useLayoutQuery} from '../page-data/loaders/use-layout-query'
import {throwErrorsIfBadResponse} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'

type ToggleFeaturePreviewOptions = {
  enabled?: boolean
  reason?: string
}

export function useToggleFeaturePreview(featureName: string) {
  const {repository} = useLayoutQuery().data

  const toggleFeature = async ({enabled, reason}: ToggleFeaturePreviewOptions = {}) => {
    const formData = new FormData()
    formData.append('feature_name', featureName)

    if (enabled !== undefined) formData.append('enabled', String(enabled))

    const normalizedReason = reason?.trim()
    if (normalizedReason) formData.append('reason', normalizedReason)

    const response = await verifiedFetch(toggleGenericFeaturePath({repo: repository}), {
      body: formData,
      method: 'POST',
    })

    throwErrorsIfBadResponse(response)
  }

  return toggleFeature
}
